import PaperTitle from './PaperTitle';

export default PaperTitle;